// extracted by mini-css-extract-plugin
module.exports = {"priceContainer":"CartLineItemPrice_priceContainer__tPUSK","oldPrice":"CartLineItemPrice_oldPrice__cZLeJ","newPrice":"CartLineItemPrice_newPrice__ghsGl"};